<template>
  <div>
    <div>
      <div class="w-full lg:max-w-md mx-auto">
        <form class="flex flex-col space-y-6">
          <div class="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-6" v-for="(dropdown, index) in dropdowns" :key="dropdown.key">
            <DropdownInput :placeholder="dropdown.label" :options="dropdown.options" v-model="dropdownValues[index]" @change="() => handleDropdownChanged(index)"></DropdownInput>
          </div>

          <div class="flex space-x-6">
            <submit-button :disabled="!canSubmit" @click="handleSubmit" />
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="mt-8">
  <div v-if="!loading && this.accordions.length">
    <div>
      <div class="px-5">
        <div class="max-w-container mx-auto">
          <div class="flex flex-col space-y-16">
            <div class="flex flex-col resources-accordion">
              <accordion-wrapper :single-only="false">
                <accordion-group v-for="accordion in accordions" :name="accordion.label" :key="accordion.uid">
                  <resource-card v-for="resource in accordion.resources" :key="resource.uid"
                                 :title="resource.title"
                                 :type="resource.type"
                                 :size="resource.filesize"
                                 :url="resource.url"
                  />
                </accordion-group>
              </accordion-wrapper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="loading" class="text-center">
    <p>Loading...</p>
  </div>
  <div v-if="submitted && !loading && !this.accordions.length" class="text-center">
    <p>Sorry, there are no resources available for that product.</p>
  </div>
  </div>
</template>

<script>
import DropdownInput from "../components/fields/DropdownInput.vue";
import SubmitButton from "../components/fields/SubmitButton.vue";
import AccordionWrapper from "../components/ResourcesAccordion/AccordionWrapper.vue";
import AccordionGroup from "../components/ResourcesAccordion/AccordionGroup.vue";
import ResourceCard from "../components/cards/ResourceCard.vue";
import resources from '../../js/api/resources'

export default {
  data() {
    return {
      productData: window.atlasProducts,
      dropdownValues: {},
      canSubmit: false,
      submitted: false,
      loading: false,
      accordions: []
    }
  },
  computed: {
    dropdowns() {
      const first = {
        label: 'Select Product Category',
        key: 'first',
        options: this.createDropdownOptions(this.productData)
      };
      let dropdowns = [first]
      let currentPosition = this.productData
      for (let dropdownVal in this.dropdownValues) {
        const currentData = currentPosition[this.dropdownValues[dropdownVal]]
        if (currentData !== undefined && Object.keys(currentData.children).length) {
          currentPosition = currentData.children
          dropdowns.push({
            label: 'Select Product Category',
            key: 'dropdownbranch' + dropdownVal,
            options: this.createDropdownOptions(currentPosition)
          })
        }
      }
      return dropdowns;
    },
    currentOption() {
      let currentPosition = this.productData
      for (let dropdownVal in this.dropdownValues) {
        const currentData = currentPosition[this.dropdownValues[dropdownVal]]
        if (currentData !== undefined && currentData && Object.keys(currentData.children).length) {
          currentPosition = currentData.children
        } else {
          currentPosition = null
        }
      }
      return currentPosition
    }
  },
  methods: {
    createDropdownOptions(data) {
      let result = [];
      for (const prop in data) {
        result.push({
          label: data[prop].element.title,
          value: data[prop].element.id,
        })
      }
      return result
    },
    handleDropdownChanged(index) {
      this.submitted = false
      const numFiltersApplied = Object.keys(this.dropdownValues).length
      for (let filterIndex = index; filterIndex < (numFiltersApplied - 1); filterIndex++) {
        const filterToReset = filterIndex + 1
        delete this.dropdownValues[filterToReset]
      }
      this.canSubmit = this.currentOption === null;
    },
    handleSubmit() {
      const product = this.dropdownValues[Object.keys(this.dropdownValues).length - 1]
      this.loading = true
      this.submitted = true
      resources.getResources(product).then((result) => {
        this.accordions = result.data
      }).finally(() => {
        this.loading = false;
      })
    }
  },
  components: {
    ResourceCard,
    AccordionWrapper,
    AccordionGroup,
    SubmitButton,
    DropdownInput
  }
};
</script>